/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PostureResourceListModel {
    getFixupPrototypeFunction() { return PostureResourceListModel.fixupPrototype; }

    static newInstance(model: Partial<PostureResourceListModel>): PostureResourceListModel {
        let obj = Object.assign(new PostureResourceListModel(), model);
        PostureResourceListModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PostureResourceListModel>): PostureResourceListModel {
        if (!model) return null;
        return PostureResourceListModel.newInstance(<PostureResourceListModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PostureResourceListModel) {
        if (!obj) return;

        models.PostureResourceListModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PostureResourceListModel): boolean {
        Object.setPrototypeOf(obj, PostureResourceListModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * region name
     */
    cloud_account_name: string;

    /**
     * category name
     */
    category: string;

    /**
     * component name
     */
    component: string;

    /**
     * resource name
     */
    resource: string;

    /**
     * resource id name
     */
    resource_id: string;

    /**
     * region/ resource group name
     */
    region_resourceGroup: string;

}
